// const main = document.querySelector('main');
const allBlocks = document.body.querySelectorAll('.block:not(.blurred-background)');
// const phase1 = document.querySelector('.phase-1');
// const phaseContent = phase1.querySelector('.phase-content');
const mainCounter = document.querySelector('.main-counter');
const loading = document.querySelector('.block.loading');
const loadingBar = document.querySelector('.loading-bar');
const drawerBtns = document.querySelectorAll('.handle');
// const loadingTime = 3000;
const loadingTime = 1000;
const interval = loadingTime / 100;
const hurryup = 60000;
const topbar = document.querySelector('.topbar');
const backBtn = topbar.querySelector('.btn.back');
const dataPopinBtns = document.querySelectorAll('[data-popin]');
const backBtnPopins = document.querySelectorAll('.popin .btn.back');
const popinsMessage = document.querySelectorAll('.popin-message');
const minus = 10;
const speed = 50;
// let phase = Number(main.dataset.phase);
let phase = 1;
console.log('phase', phase);
let milliseconds = 240000; // 4 minits
// let milliseconds = 60000; // 60 seconds
let timer = '';
let target = '';
let previousScreen = '';
let actuelScreen = '';

function count(element, value) {
    let min = value - minus < 0 ? 0 : value - minus;

    const counting = setInterval(() => {
        element.querySelector('.indicator-number').textContent = min;

        if (min < value) {
            min++;
        } else {
            clearInterval(counting);
        }
    }, speed);
}

function progressBar(element, value) {
    element.querySelector('.percentbar').style.width = `${value}%`;
    element.dataset.value = value;

    if (value >= 90) {
        element.classList.add('warning');
    }
}

function stressPlayer(element) {
    if (element.classList.contains('counter')) {
        const oldValue = Number(element.querySelector('.indicator-number').textContent);
        const newValue = Number(element.dataset.modifier);

        count(element, oldValue + newValue);
    } else if (element.classList.contains('gauge')) {
        const oldValue = Number(element.dataset.value);
        const newValue = Number(element.dataset.modifier);

        progressBar(element, oldValue + newValue);
    }
}

function stopMainCounter() {
    clearInterval(timer);
}

function millisecondsToTime(time) {
    let seconds = Math.floor(time / 1000);
    let minutes = Math.floor(seconds / 60);

    seconds = seconds % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

function checkTime() {
    if (milliseconds < hurryup && milliseconds > 0) {
        mainCounter.classList.add('hurryup');
    } else if (milliseconds <= 0) {
        mainCounter.classList.remove('hurryup');
        mainCounter.classList.add('timesup');
        stopMainCounter();
        transition(mainCounter, 'timesup');
    }
}

function startMainCounter() {
    mainCounter.textContent = millisecondsToTime(milliseconds);

    timer = setInterval(() => {
        milliseconds = milliseconds - 1000;
        mainCounter.textContent = millisecondsToTime(milliseconds);
        checkTime();
    }, 1000);
}

function buildLoading(button) {
    console.log('previousScreen', previousScreen);
    let loadingPleaseWait = '';
    let percent = 0;

    console.log('phase', phase);

    if (button.dataset.btn === 'phase-end') {
        console.log('phase', phase);
        if (phase !== 3) {
            console.log('phase', phase);
            phase++;
            main.dataset.phase = phase;
            console.log('phase', phase);
        } else {
            // on passe à la phase finale
            console.log('toto');
        }
    }

    loadingBar.style.width = `${percent}`;

    loadingPleaseWait = setInterval(() => {
        percent++;
        loadingBar.style.width = `${percent}%`;

        if (percent >= 100) {
            percent = 100;
            clearInterval(loadingPleaseWait);

            switch (previousScreen) {
                case 'screen-info-email':
                    target = `phase-welcome-phase-${phase}`;
                    break;
                case `onboarding-phase-${phase}`:
                    target = `phase-${phase}-tuto`;
                    break;
                case 'screen-info-phase-end':
                    target = `phase-welcome-phase-${phase}`;
                    break;
                default:
                    break;
            }

            transition(loading, target);
        }
    }, interval);
}

function transition(element, to) {
    // console.log('transition**************************');
    // console.log('element', element);
    // console.log('to', to);
    // console.log('previousScreen', previousScreen);
    // console.log('actuelScreen', actuelScreen);

    allBlocks.forEach(block => {
        block.classList.add('hide');
    });

    // element.closest('.block').classList.add('hide');
    previousScreen = element.closest('.block').dataset.screen;
    // console.log('previousScreen', previousScreen);

    // if (document.querySelector(`#block-${to}`) !== null) {
    document.querySelector(`#block-${to}`).classList.remove('hide');
    actuelScreen = document.querySelector(`#block-${to}`).dataset.screen;
    // console.log('actuelScreen', actuelScreen);
    // }

    switch (to) {
        case 'loading':
            buildLoading(element);
            break;
        case 'phase-1-tuto':
            document.querySelector('.phase-1').classList.remove('hide');
            break;
        case 'phase-2-tuto':
            document.querySelector('.phase-2').classList.remove('hide');
            break;
        case 'phase-3-tuto':
            document.querySelector('.phase-3').classList.remove('hide');
            break;
        case 'timesup':
            document.querySelector(`.${previousScreen}`).classList.remove('hide');
            break;
        case 'phase-end':
            document.querySelector(`.${previousScreen}`).classList.remove('hide');
            document.querySelector(`.${previousScreen}`).classList.add('blurred');
            break;
        default:
            break;
    }
}

function toggleOverflow(element, bool) {
    element.style.overflow = bool ? 'hidden' : 'scroll';
}

function goToClue(element) {
    element.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'center',
    });
}

function hideNotification(element) {
    element.classList.remove('show');
}

function displayNotification(element) {
    const ping = new Audio(`${ParamsData.wp_theme_url}assets/video/ping.mp3`);

    element.classList.add('show');
    ping.play();

    setTimeout(() => {
        element.classList.remove('show');
    }, 5000);
}

function displayBtnClue(element) {
    element.classList.remove('hide', 'inactive');
}

function toggleTopbar(bool) {
    topbar.classList[bool ? 'add' : 'remove']('back');
}

function openPopin(popin) {
    document.querySelector(`#popin-${popin}`).classList.add('show');
}

function closeMessages() {
    popinsMessage.forEach(popin => {
        popin.classList.remove('show');
    });

    toggleOverflow(document.querySelector(`.phase-${phase} .phase-content`), false);
}

function closePopins() {
    document.querySelectorAll('.popin').forEach(popin => {
        popin.classList.remove('show');
    });
}

function initPhaseElements(phase) {
    phase.querySelectorAll('.notification').forEach((notif, index) => {
        // TODO @Matthieu clearTimeout
        setTimeout(() => {
            displayNotification(notif);
        }, notif.dataset.timing * 1000);

        notif.addEventListener('click', () => {
            hideNotification(notif);
            goToClue(document.querySelector(`.btn.clue-${notif.dataset.notif}`));
        });
    });

    document.querySelectorAll('.btn.clue').forEach(btn => {
        setTimeout(() => {
            displayBtnClue(btn);
        }, btn.dataset.timing * 1000);
    });
}

function init() {
    ParamsData.points = {
        cats: Number(document.querySelector(`.block.phase-${phase} .indicator.cats`).dataset.init),
        humans: Number(document.querySelector(`.block.phase-${phase} .indicator.humans`).dataset.init),
        trust: Number(document.querySelector(`.block.phase-${phase} .indicator.trust`).dataset.init),
        vaccine: Number(document.querySelector(`.block.phase-${phase} .indicator.vaccine`).dataset.init),
    };

    console.log('init', ParamsData.points);
}

init();

document.querySelectorAll('[data-to]').forEach(cta => {
    cta.addEventListener('click', event => {
        transition(event.target, cta.dataset.to);
    });
});

drawerBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        btn.closest('.questions-drawer').classList.toggle('open');
    });
});

dataPopinBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        closeMessages();
        openPopin(btn.dataset.popin);
        toggleTopbar(true);
    });
});

popinsMessage.forEach(popin => {
    popin.querySelector('.btn.close').addEventListener('click', closeMessages);
});

backBtn.addEventListener('click', () => {
    closePopins();
    toggleTopbar(false);
});

backBtnPopins.forEach(btn => {
    btn.addEventListener('click', () => {
        closePopins();
        toggleTopbar(false);
    });
});

export { actuelScreen, displayNotification, displayBtnClue, initPhaseElements, hideNotification, goToClue, previousScreen, startMainCounter, stopMainCounter, toggleOverflow, transition, count, progressBar, stressPlayer };
